import React, { useEffect, useRef, useState } from "react";
import { useReducedMotion } from "@/hooks/useReducedMotion";

export function CustomCursor() {
  const reduced = useReducedMotion();
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (reduced) return;
    const isTouch = matchMedia("(hover: none)").matches;
    if (isTouch) return;
    setEnabled(true);
  }, [reduced]);

  useEffect(() => {
    if (!enabled) return;
    document.body.classList.add("has-custom-cursor");
    let alive = true;

    const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    const ringPos = { x: pos.x, y: pos.y };

    const move = (e) => {
      pos.x = e.clientX;
      pos.y = e.clientY;
    };
    const over = (e) => {
      const ring = ringRef.current;
      const dot = dotRef.current;
      if (!ring || !dot) return;
      const el = e.target;
      const interactive =
        el && el.closest && el.closest("button, a, [data-cursor-hover], input, textarea, [role=button]");
      if (interactive) {
        ring.style.width = "44px";
        ring.style.height = "44px";
        ring.style.borderColor = "rgba(61,198,224,0.5)";
        ring.style.background = "rgba(61,198,224,0.06)";
        dot.style.background = "#F0C45A";
      } else {
        ring.style.width = "28px";
        ring.style.height = "28px";
        ring.style.borderColor = "rgba(240,196,90,0.4)";
        ring.style.background = "transparent";
        dot.style.background = "#F6D98B";
      }
    };

    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", over);

    let raf;
    const render = () => {
      if (!alive) return;
      ringPos.x += (pos.x - ringPos.x) * 0.2;
      ringPos.y += (pos.y - ringPos.y) * 0.2;
      const dot = dotRef.current;
      const ring = ringRef.current;
      if (dot && dot.style) {
        dot.style.transform = `translate3d(${pos.x}px, ${pos.y}px, 0) translate(-50%, -50%)`;
      }
      if (ring && ring.style) {
        ring.style.transform = `translate3d(${ringPos.x}px, ${ringPos.y}px, 0) translate(-50%, -50%)`;
      }
      raf = requestAnimationFrame(render);
    };
    raf = requestAnimationFrame(render);

    return () => {
      alive = false;
      if (raf) cancelAnimationFrame(raf);
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
      document.body.classList.remove("has-custom-cursor");
    };
  }, [enabled]);

  if (!enabled) return null;
  return (
    <>
      <div
        ref={ringRef}
        aria-hidden="true"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: 28,
          height: 28,
          borderRadius: "999px",
          border: "1px solid rgba(240,196,90,0.4)",
          pointerEvents: "none",
          zIndex: 80,
          mixBlendMode: "difference",
          transition:
            "width 200ms ease, height 200ms ease, border-color 200ms ease, background 200ms ease",
        }}
      />
      <div
        ref={dotRef}
        aria-hidden="true"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: 4,
          height: 4,
          borderRadius: "999px",
          background: "#F6D98B",
          pointerEvents: "none",
          zIndex: 81,
          boxShadow: "0 0 10px rgba(240,196,90,0.7)",
        }}
      />
    </>
  );
}
